// Content-rich SEO landing pages (rendered by ContentLanding.jsx).
export const contentLandings = {
  "geschaeftsidee-testen": {
    path: "/geschaeftsidee-testen",
    breadcrumb: "Geschäftsidee testen",
    eyebrow: "Blinde-Flecken-Check · KI-gestützt",
    seo: {
      title: "Geschäftsidee testen & auf Erfolg prüfen – blinde Flecken finden | Gründio",
      description:
        "Geschäftsidee validieren, bevor es teuer wird: Die KI deckt blinde Flecken, Risiken und Denkfehler bei der Gründung auf – ehrliches Gesamt-Feedback in 60 Sekunden. Report für 29 €.",
      keywords:
        "Geschäftsidee auf Erfolg prüfen, Geschäftsidee validieren, Risiken bei der Gründung, Business Idee testen, Geschäftsidee testen",
    },
    hero: {
      lines: ["Deine Geschäftsidee brennt in deinem Kopf? Genial.", "Finde die blinden Flecken, bevor es teuer wird."],
      paragraphs: [
        "Wenn du eine neue Business-Idee hast, bist du vollgepumpt mit Adrenalin. Du siehst die Chancen, das Potenzial und den Erfolg. Das ist gut so – ohne diesen Antrieb startet niemand ein Unternehmen.",
        "Aber genau in dieser Phase hat jeder Gründer blinde Flecken. Man ist so verliebt in die eigene Idee, dass man die unsichtbaren Stolpersteine übersieht.",
        "Gründio ist dein digitaler Realitätscheck. Das Tool klopft dir nicht nur auf die Schulter – es nimmt dein Konzept auseinander und liefert dir in 60 Sekunden ein ungeschöntes Gesamt-Feedback, basierend auf statistischen Marktdaten.",
      ],
    },
    sections: [
      {
        title: "Die 3 häufigsten Denkfehler, an denen gute Ideen scheitern",
        intro:
          "Bevor du deine Geschäftsidee auf Erfolg prüfen lässt, solltest du wissen, wo die meisten Gründer unbewusst ins offene Messer laufen:",
        layout: "numbered",
        items: [
          { title: "Die „Labor-Zielgruppe“", body: "Du glaubst, jeder braucht dein Produkt. Spoiler: Wenn deine Zielgruppe „alle“ sind, ist sie in Wahrheit niemand. Ein Business funktioniert nur, wenn du ein spezifisches, brennendes Problem für eine spitze Zielgruppe löst." },
          { title: "Die unterschätzte Konkurrenz", body: "„Sowas gibt es hier noch gar nicht!“ – das hören wir oft. Meist stimmt es nicht. Und wenn wirklich niemand da ist, hat das manchmal einen harten Grund: Es gibt keinen Markt dafür. Du musst deine lokale und digitale Konkurrenzdichte glasklar kennen." },
          { title: "Die Unit Economics (die nackten Zahlen)", body: "Du weißt, was du einnehmen willst – aber kennst du deine echten operativen Kosten? Weißt du, was dich ein einziger Kunde in der Gewinnung kostet? Stimmt die Basis-Mathematik nicht, verbrennt dein Business im Alltag extrem schnell Geld." },
        ],
      },
      {
        title: "Kein verstaubter Businessplan. Ein taktisches Briefing.",
        intro:
          "Viele Gründer denken, sie müssten sofort ein 40-seitiges Businessplan-Monster schreiben. Das blockiert nur. Gründio setzt einen Schritt davor an – als dein persönlicher Sparringspartner:",
        layout: "cards",
        items: [
          { icon: "target", title: "Fehler finden, bevor sie Geld kosten", body: "Korrigiere die Schwachstellen in deinem Plan, solange es dich noch keinen Cent gekostet hat." },
          { icon: "shield", title: "Sicher argumentieren", body: "Der Report bereitet dich auf die Fragen vor, die dir später Partner, Banken oder Behörden stellen werden." },
          { icon: "lock", title: "100 % anonym & sicher", body: "Keine Angabe von Klarnamen nötig. Deine Idee bleibt deine Idee – geschützt durch unsere strikte Einweg-Schnittstelle." },
        ],
      },
    ],
    cta: {
      badge: "60-Sekunden-Realitätscheck",
      title: "Mach den 60-Sekunden-Realitätscheck",
      text: "Geh kein unnötiges Risiko bei deiner Gründung ein. Tipp deine Idee in den Analyzer ein und erhalte sofort eine tiefgehende Risiko-Bewertung, einen faktorbasierten Score für dein Modell und deinen umfangreichen Report (über 10 Seiten) zum Download.",
      buttonLabel: "Report starten & blinde Flecken aufdecken (29,00 €)",
    },
  },

  "feedback-geschaeftsidee": {
    path: "/feedback-geschaeftsidee",
    breadcrumb: "Feedback zur Geschäftsidee",
    eyebrow: "Ehrlicher Sparringspartner · neutral & datenbasiert",
    seo: {
      title: "Feedback zur Geschäftsidee: ehrliche, neutrale Bewertung | Gründio",
      description:
        "Zwischen „Alles super!“ und „Das klappt nie!“ liegt die Wahrheit. Lass deine Geschäftsidee neutral und datenbasiert bewerten – ehrliches KI-Feedback ohne Schmeichelei und ohne Angst. Report für 29 €.",
      keywords:
        "Feedback Geschäftsidee, Geschäftsidee bewerten lassen, Meinung zu Business Idee, ehrliche Meinung Startup",
    },
    hero: {
      lines: ["Zwischen „Alles super!“ und „Das klappt doch nie!“", "Warum dein Umfeld dir kein echtes Feedback geben kann."],
      paragraphs: [
        "Erzählst du im Freundes- oder Familienkreis von deiner Geschäftsidee, landest du fast immer in einer von zwei Extrem-Zonen.",
        "Die Ja-Sager-Zone: Freunde nicken höflich und sagen „Klingt spannend!“, weil sie dich motivieren wollen und Angst haben, deine Gefühle zu verletzen.",
        "Die Bedenkenträger-Zone: Die Familie sieht sofort schwarz – „Das ist viel zu riskant!“ Sie projizieren ihre eigene Angst vor dem Scheitern auf dein Projekt und bremsen dich damit komplett aus.",
        "Beide Seiten geben dir emotionales Feedback, kein wirtschaftliches. Gründio ist der neutrale Blick, der die Emotionen weglässt: kein Schmeicheln, keine Angst – nur ehrliches, datenbasiertes Feedback, das dein Business jetzt braucht.",
      ],
    },
    sections: [
      {
        title: "Warum „gut gemeint“ dich in den Ruin oder in die Blockade treibt",
        intro:
          "Wer sich vor dem Start nur auf Meinungen aus dem Umfeld verlässt, lässt eine großartige Idee sterben – oder läuft mit einem unentdeckten Fehler ins offene Messer:",
        layout: "cards",
        items: [
          { icon: "trend", title: "Totschlagen von Chancen aus Angst", body: "Viele im Angestelltenverhältnis können das Risiko einer Selbstständigkeit nicht rational einschätzen. Gründio bewertet dein Konzept anhand statistischer Marktdaten und zeigt sachlich, wo echtes Potenzial liegt." },
          { icon: "target", title: "Kritik ohne Lösungsansatz", body: "„Das gibt es doch schon“ hilft dir nicht. Findet Gründio eine Schwachstelle oder hohe Konkurrenzdichte, liefert es dir eine strategische Einwandvorwegnahme, damit du dein Modell anpassen kannst." },
          { icon: "shield", title: "Fokus vor wichtigen Terminen", body: "Ist dein Kopf voll von Zweifeln oder blindem Lob, verlierst du den Fokus. Der Report bereitet dich rational auf die Fragen von Banken, Behörden oder Geschäftspartnern vor." },
        ],
      },
      {
        title: "Kein verstaubter Businessplan. Ein taktisches Briefing.",
        intro: "Gründio ist dein neutraler Sparringspartner – einen Schritt vor dem großen Businessplan:",
        layout: "cards",
        items: [
          { icon: "target", title: "Fehler finden, bevor sie Geld kosten", body: "Korrigiere Schwachstellen, solange es dich noch keinen Cent gekostet hat." },
          { icon: "shield", title: "Sicher argumentieren", body: "Vorbereitung auf die Fragen von Partnern, Banken und Behörden." },
          { icon: "lock", title: "100 % anonym & sicher", body: "Keine Klarnamen nötig. Deine Idee bleibt geschützt durch unsere strikte Einweg-Schnittstelle." },
        ],
      },
    ],
    cta: {
      badge: "Neutrales Experten-Feedback",
      title: "Hol dir das ehrliche Feedback zu deiner Idee",
      text: "Lass die Emotionen weg. Tipp deine Idee in den Analyzer ein und erhalte sofort eine neutrale Risiko-Bewertung, einen faktorbasierten Score und deinen umfangreichen Report (über 10 Seiten) zum Download.",
      buttonLabel: "Ehrliches KI-Feedback starten (29,00 €)",
    },
  },

  "branchen-check": {
    path: "/branchen-check",
    breadcrumb: "Branchen-Check",
    eyebrow: "Branchen-Check · geführter Report statt Chatbot",
    seo: {
      title: "Branchen-Check: Risiken deiner Branche vor der Gründung prüfen | Gründio",
      description:
        "Nicht fragen. Prüfen. Gründio prüft deine Geschäftsidee strukturiert und branchenspezifisch – mit Risiko-Logik und konkreten nächsten Schritten. Ersteinschätzung gratis, vollständiger Gründio Report 29 €, kein Abo.",
      keywords:
        "Branchen-Check Gründung, Geschäftsidee prüfen Branche, Café eröffnen Risiken, Online Shop gründen worauf achten, Selbstständig machen Handwerk, SaaS Agentur gründen",
    },
    hero: {
      lines: ["Nicht fragen. Prüfen.", "Mit Gründio."],
      ctaLabel: "Geschäftsidee kostenlos prüfen",
      note: "Ersteinschätzung gratis · Vollständiger Report 29 € · Kein Abo",
      paragraphs: [
        "Gründio ist mehr als ein Chatbot: Wir analysieren deine Geschäftsidee strukturiert, branchenspezifisch und mit Blick auf die echten Risiken deiner Nische.",
      ],
    },
    sections: [
      {
        title: "Warum Gründio statt Chatbot?",
        intro:
          "Ein Chatbot liefert dir oft viele mögliche Antworten. Gründio liefert dir einen klaren, geführten Report mit Branchenfokus, Risiko-Logik und konkreten nächsten Schritten.",
        bulletsLead:
          "Wenn du eine Gründung wirklich prüfen willst, brauchst du keine lose Unterhaltung, sondern eine nachvollziehbare Einschätzung:",
        bullets: [
          "Was sind die typischen Risiken in deiner Branche?",
          "Wo sind die finanziellen oder operativen Schwachstellen?",
          "Was solltest du vor dem Start dringend anpassen?",
        ],
        note: "Genau dafür ist Gründio gebaut.",
      },
      {
        title: "Was Gründio anders macht",
        layout: "comparison",
        left: {
          label: "Ein Chatbot",
          points: [
            "Gibt allgemeine Antworten.",
            "Hängt stark von der Formulierung deiner Frage ab.",
            "Liefert kein einheitliches Ergebnisformat.",
          ],
        },
        right: {
          label: "Gründio",
          points: [
            "Arbeitet mit festen Fragen.",
            "Bewertet dein Vorhaben branchenspezifisch.",
            "Erstellt einen klaren Report mit Prioritäten, Risiken und nächsten Schritten.",
          ],
        },
      },
      {
        title: "Typische Stolpersteine",
        intro: "Jede Branche hat ihre eigenen Fallen – hier schaut Gründio besonders genau hin:",
        layout: "cards",
        cols: 2,
        items: [
          { icon: "coffee", title: "Gastronomie & lokaler Handel", body: "Hohe Fixkosten, Personal, Standortabhängigkeit und starre Auflagen werden oft zu optimistisch eingeschätzt. Gründio ordnet hier besonders Tragfähigkeit, Konkurrenzdruck und die typischen Margen-Risiken der Branche ein." },
          { icon: "shop", title: "E-Commerce & Online-Shops", body: "Viele Ideen scheitern nicht am Produkt, sondern an zu hohen Marketingkosten und zu schwacher Marge. Gründio ordnet ein, wie stark hohe Werbekosten und dünne Margen dein Modell gefährden können." },
          { icon: "wrench", title: "Handwerk & Dienstleistungen", body: "Hier liegen die Gefahren oft in der Zeit-gegen-Geld-Falle, fehlender Skalierbarkeit und problematischer Kundenstruktur. Gründio schaut auf Stundensatzlogik, Auslastung und operative Belastbarkeit." },
          { icon: "code", title: "SaaS, Agenturen & digitale Services", body: "Digitale Modelle wirken oft skalierbar, haben aber in Wahrheit Probleme bei Positionierung, Vertriebsprozess oder Kundengewinnung. Gründio prüft besonders Nutzenklarheit, Go-to-Market-Risiken und Vertriebsmachbarkeit." },
        ],
      },
      {
        title: "Branchen im Detail prüfen",
        intro: "Wähle deine Branche und sieh dir die typischen Risiken und den passenden Check an:",
        layout: "branchen-links",
      },
      {
        title: "Was du bekommst",
        paragraphs: [
          "Mit dem Branchen-Check bekommst du zuerst eine kostenlose Ersteinschätzung zu deiner Idee. Kein Fantasie-Score, sondern ein erster KI-gestützter Hinweis darauf, wo Chancen und Risikofelder liegen.",
          "Wenn du danach weitermachen willst, kannst du den vollständigen Gründio Report für 29 € freischalten. Dann erstellt Gründio deinen ausführlichen Potenzial-Report mit Branchenbezug, Risiko-Logik, Handlungsempfehlungen und persönlichen nächsten Schritten.",
        ],
        bulletsLead: "Im vollständigen Report stecken unter anderem:",
        bullets: [
          "eine branchenspezifische Risiko-Einordnung.",
          "Hinweise zu Markt, Vertrieb und Wirtschaftlichkeit.",
          "konkrete nächste Schritte für dein Modell.",
          "je nach Fall zusätzliche Orientierung zu Rechtsform, Förderungen und Umsetzungsrisiken.",
        ],
      },
      {
        title: "So läuft es ab",
        layout: "numbered",
        items: [
          { title: "Idee eingeben", body: "Du beschreibst deine Geschäftsidee in wenigen Sätzen." },
          { title: "Kostenlose Ersteinschätzung erhalten", body: "Gründio zeigt dir erste Chancen und Risikofelder deiner Nische." },
          { title: "Vollständigen Report freischalten", body: "Wenn du tiefer einsteigen willst, schaltest du für 29 € den kompletten Report frei." },
          { title: "Kurze Zusatzangaben machen", body: "Nach der Freischaltung gibst du die restlichen Angaben ein, damit der Report sauber zu deinem Vorhaben passt." },
          { title: "Report erhalten", body: "Du bekommst deinen vollständigen, personalisierten Branchen-Report inklusive konkreter nächster Schritte." },
        ],
      },
      {
        title: "Für wen das sinnvoll ist",
        bulletsLead: "Der Branchen-Check ist besonders hilfreich für:",
        bullets: [
          "Menschen mit einer konkreten Geschäftsidee, die nicht im Blindflug starten wollen.",
          "Gründer, die wissen möchten, wo in ihrer Nische die echten Risiken liegen.",
          "Selbstständige in Planung, die vor der Umsetzung eine strukturierte Ersteinschätzung wollen.",
        ],
        note: "Weniger sinnvoll ist Gründio, wenn du nur Motivation suchst oder eine rechtlich verbindliche Beratung erwartest. Der Report ist eine KI-gestützte Orientierungshilfe — keine Rechts-, Steuer- oder Unternehmensberatung.",
      },
      {
        title: "Einwände",
        layout: "faq",
        items: [
          { q: "Ist das nicht einfach nur ein Chatbot?", a: "Nein. Gründio arbeitet mit festen Eingaben, klarer Struktur und einer Auswertung, die auf deine Branche zugeschnitten ist." },
          { q: "Warum ist die Ersteinschätzung kostenlos, aber der volle Report kostenpflichtig?", a: "Weil die kostenlose Einschätzung nur ein erster Hinweis ist. Der vollständige Report ist deutlich tiefer, individueller und enthält die eigentliche Auswertung mit konkreten Handlungsempfehlungen." },
          { q: "Muss ich mich sofort festlegen?", a: "Nein. Du kannst erst die kostenlose Ersteinschätzung ansehen und dann entscheiden, ob du den vollständigen Report freischalten willst." },
        ],
      },
    ],
    cta: {
      badge: "Jetzt starten",
      title: "Prüfe deine Idee richtig — nicht mit allgemeinem Chatbot-Gefühl.",
      text: "Ersteinschätzung gratis · Vollständiger Report 29 € · Kein Abo.",
      buttonLabel: "Gründio Report starten",
    },
  },
};
